import { useFormikContext } from 'formik'
import React from 'react'
import type { LoyaltyRules } from '../../../../../types/loyalty'
import { EditableRuleCard } from './EditableRuleCard'
import { RuleNumberInput } from './RuleNumberInput'
import { RuleRow } from './RuleRow'

const Icon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
  </svg>
)

const toNumber = (value: string): number => {
  const n = parseInt(value, 10)
  return Number.isFinite(n) ? n : 0
}

export const BonusPointsCard: React.FC = () => {
  const { values, errors, setFieldValue } = useFormikContext<LoyaltyRules>()
  const e = (errors.bonus_points ?? {}) as Record<string, string>

  return (
    <EditableRuleCard
      title="Bonus Points"
      description="One-off and recurring bonuses for milestones like signup, birthday, referrals, and a flat bonus on every order"
      icon={<Icon />}
      cardPath="bonus_points"
      enablePath="bonus_points.enable"
    >
      <RuleRow
        name="Sign-up bonus"
        description="Awarded when a customer joins the loyalty program"
        control={
          <RuleNumberInput
            value={values.bonus_points.signup_bonus}
            onChange={(next) =>
              setFieldValue('bonus_points.signup_bonus', toNumber(next))
            }
            unit="pts"
            min={0}
            step={25}
            error={e.signup_bonus}
          />
        }
      />
      <RuleRow
        name="Birthday bonus"
        description="Awarded during the customer's birthday month"
        control={
          <RuleNumberInput
            value={values.bonus_points.birthday_bonus}
            onChange={(next) =>
              setFieldValue('bonus_points.birthday_bonus', toNumber(next))
            }
            unit="pts"
            min={0}
            step={25}
            error={e.birthday_bonus}
          />
        }
      />
      <RuleRow
        name="Points per order"
        description="Flat bonus on every completed order"
        control={
          <RuleNumberInput
            value={values.bonus_points.flat_points_per_order}
            onChange={(next) =>
              setFieldValue(
                'bonus_points.flat_points_per_order',
                toNumber(next),
              )
            }
            unit="pts / order"
            min={0}
            step={5}
            error={e.flat_points_per_order}
          />
        }
        isLast
      />
    </EditableRuleCard>
  )
}
